import { ResultsCard } from 'libs/searchspring/components/ResultCard'

export const ResultItem = ({ item, className, dataIndex = '0' }) => {
  if ('value' in item) {
    // Create a temporary DOM element to parse the HTML
    const tempDiv = document.createElement('div')
    tempDiv.innerHTML = item.value

    // Extract column span values
    const desktopColSpan = tempDiv.querySelector('[data-desktop-column]')?.getAttribute('data-desktop-column') || 1
    const mobileColSpan = tempDiv.querySelector('[data-mobile-column]')?.getAttribute('data-mobile-column') || 1
    const desktopSpan = desktopColSpan === 'full' ? '1 / -1' : desktopColSpan
    const mobileSpan = mobileColSpan === 'full' ? '1 / -1' : mobileColSpan

    return (
      <div
      style={`--dt-col-span: span ${desktopSpan};--mb-col-span: span ${mobileSpan}`}
      className="relative flex border-b border-r group/card border-neutral-medium col-[--mb-col-span] md:col-[--dt-col-span]">
        <div
          dangerouslySetInnerHTML={{ __html: item.value }}
          className="flex w-full h-full"
        />
      </div>
    )
  }

  return (
    <ResultsCard
      result={item}
      className={className}
      dataIndex={dataIndex}
    />
  )
}
